export default __webpack_public_path__ + "static/media/5.afb04d7e.png";